"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Asterisk = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireDefault(require("react"));

var _stencilReactDesc = require("@amzn/stencil-react-desc");

var _context = require("../context");

var _icons = require("../icons");

var _layout = require("../layout");

var _text = require("../text");

var _tooltip = require("../tooltip");

var _utils = require("../utils");

var _core = require("@emotion/core");

var _excluded = ["labelText", "htmlFor", "labelId", "error", "warning", "required", "tooltipText", "tooltipAlignment", "tooltipAltText", "renderLabel"];

var _templateObject;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var Tooltip = (0, _tooltip.withTooltip)({
  triggerVerticalAlign: 'middle'
})(_icons.IconQuestionCircle);
var AsteriskBase = (0, _context.styledWithTheme)(_text.Text.withComponent('span', {
  target: "e1do00qb0"
}))(function (_ref) {
  var theme = _ref.theme,
      color = _ref.color;
  return {
    color: theme.selectors.color(color),
    marginLeft: theme.selectors.space(_utils.LABEL_ASTERISK_SPACING)
  };
});

var Asterisk = function Asterisk(_ref2) {
  var color = _ref2.color;
  return (0, _core.jsx)(AsteriskBase, {
    color: color,
    "aria-hidden": "true"
  }, "*");
};

exports.Asterisk = Asterisk;

var defaultRenderLabel = function defaultRenderLabel(_ref3) {
  var htmlFor = _ref3.htmlFor,
      labelId = _ref3.labelId,
      color = _ref3.color,
      children = _ref3.children;
  return (0, _core.jsx)(_text.Label, {
    id: labelId,
    htmlFor: htmlFor,
    color: color
  }, children);
};

var InputHeaderDefaultProps = {
  error: false,
  warning: false,
  renderLabel: defaultRenderLabel,
  tooltipAltText: 'Show tooltip',
  required: false
};
var InputHeaderView = (0, _context.styledWithTheme)(_layout.View)(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  label {\n    & > * {\n      display: inline;\n      vertical-align: middle;\n    }\n  }\n"])));

var InputHeaderBase = function InputHeaderBase(_ref4) {
  var labelText = _ref4.labelText,
      htmlFor = _ref4.htmlFor,
      labelId = _ref4.labelId,
      _ref4$error = _ref4.error,
      error = _ref4$error === void 0 ? InputHeaderDefaultProps.error : _ref4$error,
      _ref4$warning = _ref4.warning,
      warning = _ref4$warning === void 0 ? InputHeaderDefaultProps.warning : _ref4$warning,
      _ref4$required = _ref4.required,
      required = _ref4$required === void 0 ? InputHeaderDefaultProps.required : _ref4$required,
      tooltipText = _ref4.tooltipText,
      tooltipAlignment = _ref4.tooltipAlignment,
      _ref4$tooltipAltText = _ref4.tooltipAltText,
      tooltipAltText = _ref4$tooltipAltText === void 0 ? InputHeaderDefaultProps.tooltipAltText : _ref4$tooltipAltText,
      _ref4$renderLabel = _ref4.renderLabel,
      renderLabel = _ref4$renderLabel === void 0 ? InputHeaderDefaultProps.renderLabel : _ref4$renderLabel,
      forwardedProps = (0, _objectWithoutProperties2.default)(_ref4, _excluded);
  var labelColor = _utils.LABEL_COLOR;
  var asteriskColor = _utils.LABEL_ASTERISK_COLOR;

  if (error) {
    labelColor = _utils.LABEL_ERROR_COLOR;
    asteriskColor = _utils.LABEL_ERROR_COLOR;
  } else if (warning) {
    labelColor = _utils.LABEL_WARNING_COLOR;
    asteriskColor = _utils.LABEL_WARNING_COLOR;
  }

  return (0, _core.jsx)(InputHeaderView, (0, _extends2.default)({
    display: "inline"
  }, (0, _utils.pickDataProps)(forwardedProps)), renderLabel({
    htmlFor: htmlFor,
    labelId: labelId,
    color: labelColor,
    children: (0, _core.jsx)(_layout.View, {
      display: "inline",
      minHeight: _utils.A11Y_INLINE_MIN_SIZE
    }, labelText, required && (0, _core.jsx)(Asterisk, {
      color: asteriskColor
    }))
  }), !!tooltipText && (0, _core.jsx)(Tooltip, {
    color: "primary70",
    isInline: true,
    margin: {
      left: 'S100'
    },
    title: tooltipAltText,
    tooltipText: tooltipText,
    tooltipAlignment: tooltipAlignment
  }));
};

var InputHeaderWithDocs = (0, _stencilReactDesc.describe)(InputHeaderBase).description('Header for form elements that displays a label.');
InputHeaderWithDocs.propTypes = {
  htmlFor: _stencilReactDesc.PropTypes.string.isRequired.description('The id of the form element this component is labelling.'),
  labelId: _stencilReactDesc.PropTypes.string.description('The id to apply to the label element.'),
  labelText: _stencilReactDesc.PropTypes.string.isRequired.description('Label text to display.'),
  error: _stencilReactDesc.PropTypes.bool.description('Whether the form element currently has an error.'),
  warning: _stencilReactDesc.PropTypes.bool.description('Whether the form element currently has a warning.'),
  required: _stencilReactDesc.PropTypes.bool.description('Whether the form element is required.'),
  tooltipText: _stencilReactDesc.PropTypes.string.description('Text to display in a tooltip beside the label.'),
  tooltipAlignment: _stencilReactDesc.PropTypes.oneOf(Object.values(_tooltip.TooltipAlignment)).description('Sets the tooltip alignment.'),
  tooltipAltText: _stencilReactDesc.PropTypes.string.description('Alt text for the tooltip.'),
  renderLabel: _stencilReactDesc.PropTypes.func.description('Render function to customize how the label renders based on the other props.').format("({\n  htmlFor: string,\n  labelId?: string,\n  color: string,\n  children: node\n}) => node")
};
var InputHeader = (0, _utils.withTestAttributes)({
  component: 'StencilReactInputHeader'
})(InputHeaderWithDocs);
InputHeader.defaultProps = _objectSpread({}, InputHeaderDefaultProps);
InputHeader.displayName = 'InputHeader';
var _default = InputHeader;
exports.default = _default;